import {Component, Inject, Input} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ClientService} from '../../services/client.service';

@Component({
  selector: 'app-add-client-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, FormsModule, ReactiveFormsModule],
  templateUrl: './add-client-dialog.component.html',
  styleUrls: ['./add-client-dialog.component.css'],
  providers: [ClientService],
})
export class AddClientDialogComponent {
  protected powerBILink = '';
  protected nrj_id = '';

  constructor(
    public dialogRef: MatDialogRef<AddClientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clientService: ClientService,
  ) {
    this.powerBILink = data?.powerBILink || '';
    this.nrj_id = data?.nrj_id || '';
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(this.powerBILink);
    this.clientService.updateClient(this.nrj_id, this.powerBILink).subscribe({
      next: result => {

      },
      error: err => {

      }
    })
  }
}
